/**
 * useAuditEnabled Hook
 *
 * Centralized hook to determine if audit features (JotAudit, CPT codes, etc.) should be enabled.
 * Returns true if any of the following conditions are met:
 * - payer_template_note_processing feature flag is enabled
 * - jotaudit feature flag is enabled
 * - bundling is enabled for the user
 */

import { useBundlingEnabled } from '@features/subscriptions';
import { useFeatureFlag } from '@features/user';

export function useAuditEnabled(): boolean {
  const isPayerTemplateProcessingEnabled = useFeatureFlag('payer_template_note_processing');
  const isJotAuditEnabled = useFeatureFlag('jotaudit');
  const { isBundlingEnabled } = useBundlingEnabled();

  return isPayerTemplateProcessingEnabled || isJotAuditEnabled || isBundlingEnabled;
}
